module.exports = __webpack_public_path__ + "338c7376.woff2";